import { FC } from 'react';

import { ChartContainerProps } from './ChartContainer.types';
import { StyledChartContainer } from './ChartContainer.styles';

const ChartContainer: FC<ChartContainerProps> = ({ children, css }) => {
  return <StyledChartContainer css={{ ...css }}>{children}</StyledChartContainer>;
};

export default ChartContainer;
